import styled from 'styled-components';

export const CssTransitionWrapper = styled.div<{ timeout: number }>`
    min-width: 100%;
    position: absolute;
    top: 0;
    left: 0;

    &.forward-enter {
        opacity: 0.5;
        transform: translateX(100%);
    }
    &.forward-enter-active {
        opacity: 1;
        transform: translateX(0%);
        transition: all ${({ timeout }) => timeout}ms;
    }
    &.forward-exit {
        opacity: 1;
        transform: translateX(0%);
    }
    &.forward-exit-active {
        opacity: 0.5;
        transform: translateX(-100%);
        transition: all ${({ timeout }) => timeout}ms;
    }

    &.backward-enter {
        opacity: 0.5;
        transform: translateX(-100%);
    }
    &.backward-enter-active {
        opacity: 1;
        transform: translateX(0%);
        transition: all ${({ timeout }) => timeout}ms;
    }
    &.backward-exit {
        opacity: 1;
        transform: translateX(0%);
    }
    &.backward-exit-active {
        opacity: 0.5;
        transform: translateX(100%);
        transition: all ${({ timeout }) => timeout}ms;
    }
`;
